import { FAMILY_LINK_PAGES } from "@marble/core/modules/students/family-links/constants";

const FAMILY_PAGE_PATH = new RegExp(
  `^/students/\\d+/(${FAMILY_LINK_PAGES.join("|")})$`,
);

/**
 * Whether a path is one of the family pages, e.g. to accept it as the place
 * to return to after a family signs in. Never a looser match: this decides
 * where a sign-in may send someone. Its own module, with no signing code,
 * so browser code can import it.
 */
export const isFamilyPagePath = (path: string | null | undefined): boolean =>
  !!path && FAMILY_PAGE_PATH.test(path);
